<template>
  <b-modal
    ref="reward-affiliate-excel"
    hide-footer
    :title="titleExcel"
    id="reward-affiliate-excel"
    no-close-on-backdrop
    size="xl"
  >
    <div>
      <b-row>
        <b-col>
          <div class="form-group">
            <span>
              <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel đúng
              format, hoặc có thể tải ở
              <a :href="urlExcel">đây</a>
            </span>
          </div>
        </b-col>
      </b-row>
      <span> <b>Bước 2:</b> Tiến hành Import </span>
      <b-row>
        <b-col>
          <UploadFileMulter
            v-on:send-file="getDataFromExcel"
            v-on:clear-file="clearFileExcel"
            :cmdUrl="'reward-affiliates/format-import-excel'"
          />
          <span v-if="fileName"
            >Tên file: <b>{{ fileName }}</b>
          </span>
        </b-col>
      </b-row>
      <!-- End input session -->
    </div>
    <div class="mt-10" v-show="importItemsLength !== 0">
      <hr
        class="hr-text"
        data-content="Danh sách sản phẩm hoa hồng Affiliate"
        style="font-weight: 600"
      />
      <b-table
        class="import-excel-product-table"
        caption-top
        responsive
        bordered
        hover
        :fields="fields"
        :items="importItems"
        id="my-table"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle ml-3"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(productName)="row">
          <p
            v-if="row.item.productCode"
            style="font-size: 12px; font-weight: 500; margin-bottom: 0"
          >
            ( {{ row.item.productCode }} )
          </p>
          <span
            v-text="row.item.productName"
            style="white-space: normal; color: #3699ff"
          ></span>
        </template>

        <template #cell(statusValidate)="data">
          <div v-if="!data.item.onLoading">
            <div class="d-table-cell align-middle" style="width: 10%">
              <i
                v-b-tooltip.hover
                :title="htmlGetStatusValidate(data.item.isError, 'title')"
                :class="htmlGetStatusValidate(data.item.isError, 'class')"
              ></i>
            </div>
          </div>
          <div v-else>
            <b-spinner small variant="primary" class="mr-2"></b-spinner>
            <span class="text-primary">Đang xử lí...</span>
          </div>
        </template>
      </b-table>
      <b-col class="row mt-3">
        <b>
          Tổng số dòng:
          {{ importItemsLength }}
        </b>
      </b-col>
      <b-pagination
        v-show="importItemsLength > perPage"
        v-model="currentPage"
        :total-rows="importItemsLength"
        :per-page="perPage"
        aria-controls="my-table"
        align="right"
      ></b-pagination>
    </div>
    <b-overlay
      v-if="importItemsLength"
      :show="onLoadingList"
      rounded
      opacity="0.6"
      class="d-inline-block mr-3"
    >
      <template #overlay>
        <div class="d-flex align-items-center">
          <b-spinner variant="light" small type="grow"></b-spinner>
        </div>
      </template>
      <b-button
        style="width: 80px"
        class="mt-6"
        :disabled="onLoadingList || !importItemsLength"
        v-if="importItemsLength"
        variant="primary"
        size="sm"
        @click="onSave"
      >
        <strong>Lưu</strong>
      </b-button>
    </b-overlay>

    <b-button
      class="mt-6"
      style="width: 80px"
      variant="secondary"
      size="sm"
      @click="hideModalExcel"
    >
      <strong>Hủy</strong>
    </b-button>
  </b-modal>
</template>
<script>
import { cloneDeep, convertPrice, makeToastFaile } from '@/utils/common';
import UploadFileMulter from '@/view/modules/upload/UploadFileMulter';
import { URL_IMPORT_PRODUCT_REWARD_AFFILIATE } from '@/utils/constants';
import { keyBy } from 'lodash';
const thStyleCommon = {
  textAlign: 'center',
  fontWeight: 600,
  color: '#181c32',
  width: '5%',
};

export default {
  name: 'ImportWarrantyItemModal',
  props: {
    rewardAffiliateDetails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      titleExcel: 'Nhập excel sản phẩm thưởng Affiliate',
      urlExcel: URL_IMPORT_PRODUCT_REWARD_AFFILIATE,
      onLoadingList: false,
      currentPage: 1,
      perPage: 10,
      file: null,
      importItems: [],
      isBusy: false,
      fileName: '',
      fields: [
        {
          key: 'productId',
          label: 'ID',
          thStyle: {
            ...thStyleCommon,
            width: '10%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'productName',
          label: 'Sản phẩm',
          thStyle: {
            ...thStyleCommon,
            width: '30%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'commissionRate',
          label: 'Tỷ lệ hoa hồng',
          thStyle: {
            ...thStyleCommon,
            width: '10%',
          },
          tdClass: 'text-center align-middle',
        },
        {
          key: 'statusValidate',
          label: 'Trạng thái',
          thStyle: {
            ...thStyleCommon,
            width: '7%',
          },
          tdClass: 'align-middle text-center',
        },
        {
          key: 'errorMessage',
          label: 'Thông báo lỗi',
          thStyle: {
            ...thStyleCommon,
            width: '15%',
          },
          tdClass: 'text-center align-middle',
        },
      ],
    };
  },
  components: {
    UploadFileMulter,
  },
  computed: {
    importItemsLength() {
      return this.importItems.length;
    },
  },
  methods: {
    convertPrice,
    hideModalExcel() {
      this.$refs['reward-affiliate-excel'].hide();
      this.clearFileExcel();
    },
    showModal() {
      this.$refs['reward-affiliate-excel'].show();
    },
    onSave: function () {
      const items = cloneDeep(this.importItems);
      const inValidItem = items.find((item) => item.isError);
      if (inValidItem) {
        return makeToastFaile('Vui lòng nhập dự liệu hợp lệ!');
      }
      this.hideModalExcel();
      this.$emit('on-receipt-reward-affiliate', items);
    },
    htmlGetStatusValidate(isError, type) {
      let name = '';
      switch (isError) {
        case false: {
          name =
            type === 'class'
              ? 'fas fa-check-circle text-success'
              : 'Sẵn sàng tạo mới';
          break;
        }
        default: {
          name =
            type === 'class'
              ? 'fas fa-times-circle text-danger'
              : 'Không hợp lệ';
          break;
        }
      }
      return name;
    },
    getDataFromExcel(data, fileName) {
      this.fileName = fileName;
      const rewardAffiliateDetailsMap = keyBy(
        this.rewardAffiliateDetails,
        'productId',
      );
      this.importItems = [...data.rows].map((item) => {
        const hasDuplidateProduct = rewardAffiliateDetailsMap[item.productId];
        if (hasDuplidateProduct) {
          item.isError = true;
          item.errorMessage = 'Sản phẩm đã tồn tại!';
        }
        return {
          ...item,
          onLoading: false,
        };
      });
      this.onLoadingList = false;
    },
    clearFileExcel() {
      this.importItems = [];
      this.fileName = '';
      this.file = null;
      this.onLoadingList = false;
    },
  },
};
</script>

<style lang="scss">
.reward-affiliate-excel {
  table.b-table[aria-busy='true'] {
    opacity: 0.6;
  }
  .modal-dialog.modal-xl {
    max-width: 95vw;
  }
}
</style>
